export default "__VITE_ASSET__CpTUcNZw__"